import "./LocalSeoConsultantWolverhampton.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import CaseStudies from "./sections/CaseStudies";
import Methodology from "./sections/Methodology";
import Benefits from "./sections/Benefits";
import Wolverhampton from "./sections/Wolverhampton";
import Localseo from "./sections/Localseo";
import LocalHero from "./sections/LocalHero";
import Localseofaq from "./sections/Localseofaq";
import Wolverhamptonmarketanalysis from "./sections/Wolverhamptonmarketanalysis";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantWolverhamptonPage() {
  return <div>
      <Header />
      <Services />
      <CaseStudies />
      <Methodology />
      <Benefits />
      <Wolverhampton />
      <Localseo />
      <LocalHero />
      <Localseofaq />
      <Wolverhamptonmarketanalysis />
      <Consultation />
      <Footer />
    </div>;
}